import { createFeatureSelector, MemoizedSelector } from '@ngrx/store';
import { State } from '../../store';

export const selectState: MemoizedSelector<
  object,
  State
  > = createFeatureSelector<State>('Pathways');
